// Agent-record endpoints — docs/real-estate/be/10-api-reference.md §A6.
// Agents have no active/inactive status (only projects do); to stop an
// agent being booked, unassign them from a project (properties.js's
// setProjectAgents) or delete the record entirely.
import { request } from './http';

export function listAgents(query) {
  return request({ path: '/properties/agents', params: query });
}

export function createAgent(fields) {
  return request({ method: 'post', path: '/properties/agents', data: fields });
}

export function getAgent(agentId) {
  return request({ path: `/properties/agents/${agentId}` });
}

export function patchAgent(agentId, fields) {
  return request({
    method: 'patch',
    path: `/properties/agents/${agentId}`,
    data: fields,
  });
}

export function deleteAgent(agentId) {
  return request({ method: 'delete', path: `/properties/agents/${agentId}` });
}
